import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeSelectedLabelIdFilterSelector } from "~/store/selectors/selector.configOptions";
import { makeAvailableLabelFiltersByProjectIdSelector } from "~/store/selectors/selector.tasks";

export const useLabelsFilterData = (projectId) => {
  const getSelectedLabelIdFilterSelector = useMemo(makeSelectedLabelIdFilterSelector, []);

  const getLabelFiltersByProjectId = useMemo(makeAvailableLabelFiltersByProjectIdSelector, []);

  const selected = useSelector((state) => getSelectedLabelIdFilterSelector(state, projectId));

  const availableLabelFilters = useSelector((state) => getLabelFiltersByProjectId(state, projectId));

  const options = useMemo(() => {
    const result = [];

    availableLabelFilters.forEach((labelFilter) => {
      result.push({
        id: labelFilter.id,
        name: `${labelFilter.name}`,
        additionalInfo: `(${labelFilter.openTasksCount}/${
          labelFilter.completedTasksCount + labelFilter.openTasksCount
        })`,
      });
    });

    return result;
  }, [availableLabelFilters]);

  return [selected, options];
};
